var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLawyerLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#57595a",
    d: "M12 6.333v8.333c0 .736-.598 1.334-1.334 1.334H1.333A1.335 1.335 0 0 1 0 14.667V6.333C0 6.15.149 6 .333 6h1V4.666A4.672 4.672 0 0 1 6 0a4.672 4.672 0 0 1 4.666 4.666V6h1c.185 0 .334.149.334.333zm-5.213 4.74c.342-.25.546-.642.546-1.073a1.334 1.334 0 0 0-2.667 0c0 .43.204.824.546 1.072l-.21 1.891a.334.334 0 0 0 .33.37h1.334a.334.334 0 0 0 .332-.37zm1.88-6.407A2.67 2.67 0 0 0 6 2a2.67 2.67 0 0 0-2.667 2.666V6h5.333z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLawyerLock);
export default __webpack_public_path__ + "static/media/icon-lawyer-lock.fcd8eb6e.svg";
export { ForwardRef as ReactComponent };